import request from '@/utils/request';
const api1 = process.env.VUE_APP_BASE_API1;
const url1 = (path) => api1 + path;


export function login(data) {
  return request({
    url: url1('/admin/logins'),
    method: 'post',
    data,
  });
}

export function getInfo() {
  return request({
    url: url1('/getUser'),
    method: 'get',
  });
}

export function logout() {
  return request({
    url: url1('/admin/loginout'),
    method: 'get',
  });
}
